/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string, number, object } from 'prop-types'
import { jsx, Label, Textarea, Flex, Text } from 'theme-ui'
import { useField } from 'formik'
import './formInputs.css'
import { HelperText, ErrorMessage } from './Common'
// Custom input field that adds Formik functionality to theme-ui's Textarea, and adds our styling.
const TextArea = ({
  label,
  showCount,
  maxLength = 500,
  containerProps,
  ...props
}) => {
  const [field, meta] = useField(props)
  const count = meta && meta.value ? meta.value.length : 0

  return (
    <Flex
      sx={{
        mb: 5,
        flexDirection: 'column',
        width: '100%',
        ...containerProps,
      }}
    >
      <Label htmlFor={props.name}>{label}</Label>
      <HelperText>{props.helperText}</HelperText>
      <Textarea
        {...field}
        {...props}
        maxLength={maxLength}
        sx={{
          bg:
            meta.touched && meta.error
              ? 'inputError'
              : !meta.error && meta.value
              ? 'inputSuccess'
              : 'inputBackground',
          marginBottom: 2,
        }}
      />
      <Flex>
        <Flex>
          {meta.touched && meta.error ? (
            <ErrorMessage>{meta.error}</ErrorMessage>
          ) : null}
        </Flex>
        <Flex sx={{ marginLeft: 'auto' }}>
          {showCount && (
            <Text as="p" sx={{ color: 'muted', float: 'right', mb: 0 }}>
              {maxLength - count} / {maxLength}
            </Text>
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}

TextArea.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  helperText: string,
  showCount: bool,
  maxLength: number,
  containerProps: object,
}

export default TextArea
